import { EProblemReportDateFilter } from '@constants';
import { IProblemReportFilters } from '@sdk/contracts';

export const areFiltersApply = (filters: IProblemReportFilters & { search?: string }) => {
  const { tags, type, courseIds, reportStatus, date, dateRange, search } = filters;

  const hasArrayFilter = (arr?: unknown[]) => Array.isArray(arr) && arr.length > 0;
  const hasStringFilter = (str?: string) => str && typeof str === 'string' && str.trim().length > 0;

  if (hasArrayFilter(tags)) return true;
  if (hasArrayFilter(courseIds)) return true;
  if (hasArrayFilter(reportStatus)) return true;
  if (hasStringFilter(type)) return true;
  if (hasStringFilter(search)) return true;

  if (date && date !== EProblemReportDateFilter.ALL) {
    if (date === EProblemReportDateFilter.CUSTOM_RANGE) {
      return hasArrayFilter(dateRange);
    }
    return true;
  }

  return false;
};
